module.exports = __webpack_public_path__ + "img/2estrellas_.3fa83422.png";